import { useRef, useState } from 'react';

import { useDialog } from '../../../dialog/useDialog';

import { Report } from '../../interfaces';

export const useReportDetails = () => {
  const [selectedReportDetails, setSelectedReportDetails] = useState<Report>();
  const { isDialogOpen, handleOpenDialog, handleCloseDialog } = useDialog();

  const handleOpenDetailsDialog = useRef((report: Report) => {
    handleOpenDialog();
    setSelectedReportDetails(report);
  });

  const handleCloseDetailsDialog = () => {
    handleCloseDialog();
  };

  return {
    selectedReportDetails,
    openDetailsDialog: isDialogOpen,
    handleOpenDetailsDialog: handleOpenDetailsDialog.current,
    handleCloseDetailsDialog
  };
};
